import React, { useState } from "react";
import PlusIcon from "../../assets/icons/plus";
import TimerSVG from "../../assets/icons/timerbg";

const WorkTimerCard = ({ time, isCheckedIn, handleClick }) => {
  return (
    <div className="relative w-full h-auto min-h-60 rounded-xl overflow-hidden bg-[#142b70] flex flex-col items-center justify-center p-6">
      {/* Background SVG */}
      <TimerSVG />

      {/* Status text */}
      <p className="absolute top-4 left-4 text-xs sm:text-sm text-[#f6f6f8]/70 z-10">
        {isCheckedIn ? "You are Checked In" : "Not Checked In Yet"}
      </p>

      {/* Timer */}
      <div className="text-center z-10">
        <span className="text-sm text-[#f6f6f8]/50">Work Timer</span>
        <br />
        <span className="text-2xl sm:text-3xl font-medium mt-2 text-[#f6f6f8] block">
          {time}
        </span>
      </div>

      {/* Toggle Button */}
      <div className="mt-6 z-10 absolute bottom-5 hidden sm:block">
        <button
          onClick={handleClick}
          className="flex items-center gap-2 px-4 py-2 rounded bg-white hover:bg-gray-100 transition"
        >
          <span className="text-sm font-medium text-[#de2b26]">
            {isCheckedIn ? "Check Out" : "Start Working By Checking In"}
          </span>
        </button>
      </div>
    </div>
  );
};

export default WorkTimerCard;
